import { Dispatch, SetStateAction, useEffect, useState } from 'react';

interface UsePopoverDismissResult {
  showTracesPopover: boolean;
  setShowTracesPopover: Dispatch<SetStateAction<boolean>>;
  showToolCallsPopover: boolean;
  setShowToolCallsPopover: Dispatch<SetStateAction<boolean>>;
  showTipsMenu: boolean;
  setShowTipsMenu: Dispatch<SetStateAction<boolean>>;
}

export function usePopoverDismiss(): UsePopoverDismissResult {
  const [showTracesPopover, setShowTracesPopover] = useState(false);
  const [showToolCallsPopover, setShowToolCallsPopover] = useState(false);
  const [showTipsMenu, setShowTipsMenu] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;

      if (
        showTracesPopover &&
        !target.closest('.traces-container') &&
        !target.closest('.traces-button')
      ) {
        setShowTracesPopover(false);
      }
      if (
        showToolCallsPopover &&
        !target.closest('.tool-calls-container') &&
        !target.closest('.tool-calls-button')
      ) {
        setShowToolCallsPopover(false);
      }
      if (
        showTipsMenu &&
        !target.closest('.tips-menu-container') &&
        !target.closest('.tips-menu-button')
      ) {
        setShowTipsMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showTracesPopover, showToolCallsPopover, showTipsMenu]);

  return {
    showTracesPopover,
    setShowTracesPopover,
    showToolCallsPopover,
    setShowToolCallsPopover,
    showTipsMenu,
    setShowTipsMenu,
  };
}
